import { Link, useNavigate } from "react-router-dom";
import { Card } from "../Components/Card";
import React, { createContext, useContext } from "react";
import { useTranslation } from "react-i18next";
import { NetworkIcon } from "../Components/Icons/NetworkIcon";
import { ServerIcon } from "../Components/Icons/ServerIcon";
import { WebAPIIcon } from "../Components/Icons/WebAPIIcon";
import { Colors } from "../constants/Colors";

const detailMetadata = {
  "Internet Online": {
    color: Colors.alertsgreen100,
    link: "internet-online",
  },
  "Internet Offline": {
    color: Colors.alertsred100,
    link: "internet-offline",
  },
  "Internet Tech Issue": {
    color: "#a7a9ac",
    link: "internet-technical-issue",
  },
  "Internet Suspend": {
    color: Colors.alertsyellow100,
    link: "internet-suspend",
  },
  "Device Clear": {
    color: Colors.alertsgreen100,
    link: "device-clear",
  },
  "Device Attention": {
    color: Colors.alertsyellow100,
    link: "device-attention",
  },
  "Device Down": {
    color: Colors.alertsred100,
    link: "device-down",
  },
};

const MetadataContext = createContext(null);

const useMetadata = () => useContext(MetadataContext);

const MetadataProvider = ({ metadata, children }) => {
  return (
    <MetadataContext.Provider value={metadata}>
      {children}
    </MetadataContext.Provider>
  );
};

export const DeviceDetailCard = ({ headerText, loginType, data, loading }) => {
  return loginType === "prime" ? (
    <PrimeDeviceDetailCard headerText={headerText} data={data} loading={loading} />
  ) : (
    <HiDeviceDetailCard headerText={headerText} data={data} />
  );
};

const PrimeDeviceDetailCard = ({ headerText, data, loading }) => {
  const metadata = detailMetadata[headerText];

  const { t } = useTranslation();

  return (
    <MetadataProvider metadata={metadata}>
      <Card
        style={{
          display: "grid",
          gridTemplateRows: "auto 1fr",
          padding: "0.5rem",
          fontSize: "1rem",
          overflow: "hidden",
          height: window.innerWidth <= 600 ? "7rem" : "auto",
        }}
      >
        <CardHeader headerText={headerText} count={data.length} />
        { data.length > 0 ? (
        <div
          style={{
            overflowX: "hidden",
            overflowY: "auto",
            width: "100%",


          }}
        >
          {data.map((el, idx) => (
            <CardSubItem subItem={el} key={`${headerText}-${idx}`} />
          ))}
        </div>
        ) : 
        loading ? (
          <div style={{ padding: "1rem", textAlign: "center", fontSize: "0.8rem", fontWeight: 500 }}>Loading...</div>
        ) :
        (
          <div style={{ padding: "1rem", textAlign: "center" }}>{t("general.noData")}</div>
        )}
      </Card>
    </MetadataProvider>
  );
};

export const HiDeviceDetailCard = ({ headerText, data }) => {
  const metadata = detailMetadata[headerText];

  const { t } = useTranslation();

  return (
    <MetadataProvider metadata={metadata}>
      <Card
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "0.5rem",
          fontSize: "1rem",
          width: "100%",
          overflowX: "hidden",
          // maxWidth: "400px"
        }}
      >
        <div style={{ width: "100%" }}>
          <CardHeader headerText={headerText} count={data.length} />
          {data.length > 0 ? (
            <div
              style={{
                // display: "flex",
                // flexDirection: "column",
                // justifyContent: "center",
                height: "65px",
                overflowX: "hidden",
                overflowY: "auto",
                width: "100%",
              }}
            >
              {data.map((el) => (
                <CardSubItem subItem={el} />
              ))}
            </div>
          ) : (
            <div style={{ padding: "1rem", textAlign: "center" }}>
              {t("general.noData")}
            </div>
          )}
        </div>
      </Card>
    </MetadataProvider>
  );
};

const CardHeader = ({ headerText, count }) => {
  const { t } = useTranslation();
  const metadata = useMetadata();
  return (
    <div
      style={{
        display: "flex",
        backgroundColor: Colors.neutral10,
        justifyContent: "space-between",
        padding: "3px 10px",
        borderRadius: "5px",
        fontWeight: "bold",
        fontSize: "0.8rem",
        width: "100%",
      }}
    >
      <div>
        <span
          style={{
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: metadata.color,
            display: "inline-block",
            marginRight: "10px",
          }}
        ></span>
        {headerText}
      </div>
      {count > 0 && (
        <Link
          to={metadata.link}
          style={{ color: Colors.primary100, fontWeight: "normal" }}
        >
          {t("prime.deviceList.viewAll")}
        </Link>
      )}
    </div>
  );
};

const CardSubItem = ({
  subItem: { name, identifier, lastUpdated, description, id, type },
}) => {
  const navigate = useNavigate();
  const metadata = useMetadata();
  return (
    <div
      style={{
        display: "flex",
        gap: "0.5rem",
        width: "100%",
        margin: "8px",
        marginBottom: "0",
        flexGrow: "1",
        cursor: "pointer",
        borderLeft: `5px solid ${metadata.color}`,
        paddingLeft: "0.4rem",
        // height: "100%",
      }}
      onClick={() => navigate(`device-detail-analysis/${type}/${id}`)}
    >
      <div style={{height: "100%", alignItems: "center", alignContent: "center", alignSelf: "center"}}>
        {type === "server" && <ServerIcon style={{ width: "20px", height: "20px", alignItems: "center", alignContent: "center", alignSelf: "center" }} isBlack={true} />}
        {type === "network" && <NetworkIcon style={{ width: "20px", height: "20px" }} isBlack={true} />}
        {type === "webapi" && <WebAPIIcon style={{ width: "20px", height: "20px" }} isBlack={true} />}
        </div>
      <div
        style={{
          flexGrow: "1",
          fontSize: "0.8rem",
        }}
      >
        

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "95%",
            fontWeight: "bold",
          }}
        >
          <div
            style={{
              fontWeight: 700,
              fontSize: "0.8rem",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "60%",
            }}
          >
            {name.slice(0, 20).concat(name.length > 20 ? "..." : "")}
          </div>
          <div
            style={{
              width: "4px",
            }}
          ></div>
          <div
            style={{
              fontWeight: 500,
              fontSize: "0.7rem",
            }}
          >
            {lastUpdated}
          </div>
        </div>
        <div style={{ color: "#525252" }}>{identifier}</div>
        <div
          style={{
            fontSize: "0.7rem",
            width: "100%",
          }}
        >
          {description.map((el, idx) => (
            <div key={`${idx}-${el}`}>
              {el}
              <br />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
